<template>
    <div class="column-selector">
        <div class="columns-container">
            <div class="column-group" v-for="group in columnGroups" :key="group.key">
                <h3>{{ group.label }}</h3>
                <div v-for="field in group.fields" :key="field.key" class="field-item">
                    <a-switch v-model="localSelectedColumns[field.key]" class="custom-switch" />
                    <span class="field-label">{{ field.title }}</span>
                </div>
            </div>
        </div>
        <div class="actions">
            <a-button @click="cancel">{{ $t("wp.cancel") }}</a-button>
            <a-button type="primary" @click="save">{{ $t("ticket.save")}}</a-button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "SiteColumnSelector",
    props: {
        selectedColumns: {
            type: Array,
            required: true,
        },
        allColumns: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            localSelectedColumns: {},
            columnGroups: [],
        };
    },
    created() {
        // Tüm sütun gruplarını ve alanlarını organize et
        this.organizeColumns();

        // Seçilen sütunları localSelectedColumns'a aktar
        this.selectedColumns.forEach((column) => {
            this.$set(this.localSelectedColumns, column, true);
        });
    },
    methods: {
        organizeColumns() {
            const groups = {};

            this.allColumns.forEach(column => {
                if (!groups[column.group]) {
                    groups[column.group] = {
                        key: column.group,
                        label: this.getGroupLabel(column.group),
                        fields: [],
                    };
                }
                groups[column.group].fields.push({
                    key: column.key,
                    title: column.title,
                });
            });

            this.columnGroups = Object.values(groups);
        },
        getGroupLabel(groupKey) {
            switch(groupKey) {
                case 'siteFields':
                    return 'Site Alanları';
                case 'invoiceFields':
                    return 'Fatura Alanları';
                case 'planFields':
                    return 'Plan Alanları';
                case 'usageFields':
                    return 'Kullanım Alanları';
                default:
                    return groupKey;
            }
        },
        cancel() {
            this.$emit("cancel");
        },
        save() {
            const updatedColumns = Object.keys(this.localSelectedColumns).filter(
                (column) => this.localSelectedColumns[column]
            );

            this.$emit("save", updatedColumns);
        },
    },
});
</script>

<style lang="scss" scoped>
.column-selector {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;

    .columns-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row; /* Grupları yanyana yerleştir */

        .column-group {
            margin-bottom: 20px;
            margin-right: 40px;
            flex: 1; /* Grupların eşit genişlikte olmasını sağlar */
            min-width: 200px; /* Grupların minimum genişliğini belirler */

            border-left: 1px solid #e0e0e0;
            padding-left: 20px;

            &:first-child {
                border-left: none;
                padding-left: 0;
            }

            h3 {
                margin-bottom: 10px;
                font-size: 16px;
                color: #333;
            }

            .field-item {
                display: flex;
                align-items: center;
                margin-bottom: 8px;

                .custom-switch {
                    margin-right: 8px;
                }

                .field-label {
                    font-size: 14px;
                    color: #555;
                }
            }
        }
    }

    .actions {
        display: flex;
        justify-content: flex-end;

        a-button {
            margin-left: 10px;
        }
    }
}
</style>
